<template>
  <CFooter :fixed="false" class="d-flex justify-content-center">
      <span>&copy; {{new Date().getFullYear()}} - Powered by Center for Information Technology Services
</span>
  
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
